import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import axios from "axios";
import { captureUtmParams } from "@/lib/utm";
import LandingPage from "@/pages/LandingPage";
import FeedbackForm from "@/pages/FeedbackForm";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Settings from "@/pages/Settings";
import Plans from "@/pages/Plans";
import MyCustomers from "@/pages/MyCustomers";
import PublicCheckout from "@/pages/PublicCheckout";
import ThankYou from "@/pages/ThankYou";
import AdminMaster from "@/pages/AdminMaster";
import AffiliateRegister from "@/pages/AffiliateRegister";
import AffiliateLogin from "@/pages/AffiliateLogin";
import AffiliateDashboard from "@/pages/AffiliateDashboard";
import ReferralRedirect from "@/pages/ReferralRedirect";
import OwnerReferralRedirect from "@/pages/OwnerReferralRedirect";
import AffiliateInviteRedirect from "@/pages/AffiliateInviteRedirect";
import ResetPassword from "@/pages/ResetPassword";
import PartnerLanding from "@/pages/PartnerLanding";
import PartnerPanel from "@/pages/PartnerPanel";
import PartnerAccess from "@/pages/PartnerAccess";
import AffiliateLanding from "@/pages/AffiliateLanding";
import CalcularPerda from "@/pages/CalcularPerda";
import CadastroFeira from "@/pages/CadastroFeira";
import PaginaOK from "@/pages/PaginaOK";
import CadastroParceiro from "@/pages/CadastroParceiro";
import CadastroAfiliado from "@/pages/CadastroAfiliado";
import CookieConsent from "@/components/CookieConsent";
import Apresentacao from "@/pages/Apresentacao";
import MagicRedirect from "@/pages/MagicRedirect";
import { AuthProvider } from "@/context/AuthContext";

// Global Axios: handle 401 gracefully — redirect to login instead of showing raw errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      const path = window.location.pathname;
      // Only redirect for protected pages, not public ones
      const publicPaths = ['/', '/login', '/register', '/checkout', '/obrigado', '/afiliados', '/afiliado', '/vendedor', '/parceiro', '/convite'];
      const isPublic = publicPaths.some(p => path === p || path.startsWith(p + '/'));
      if (!isPublic && path !== '/master') {
        localStorage.removeItem('token');
        window.location.href = '/login';
        return new Promise(() => {}); // Prevent error from bubbling
      }
    }
    return Promise.reject(error);
  }
);

function App() {
  useEffect(() => { captureUtmParams(); }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/clientes" element={<MyCustomers />} />
          <Route path="/checkout/:planId" element={<PublicCheckout />} />
          <Route path="/obrigado" element={<ThankYou />} />
          <Route path="/master" element={<AdminMaster />} />
          <Route path="/admin-master" element={<AdminMaster />} />
          <Route path="/afiliados" element={<AffiliateRegister />} />
          <Route path="/afiliados/login" element={<AffiliateLogin />} />
          <Route path="/afiliados/painel" element={<AffiliateDashboard />} />
          <Route path="/ref/:slug" element={<ReferralRedirect />} />
          <Route path="/convite/:code" element={<AffiliateInviteRedirect />} />
          <Route path="/indicacao/:code" element={<OwnerReferralRedirect />} />
          <Route path="/indica%C3%A7%C3%A3o/:code" element={<OwnerReferralRedirect />} />
          <Route path="/indicação/:code" element={<OwnerReferralRedirect />} />
          <Route path="/resetar-senha" element={<ResetPassword />} />
          <Route path="/parceiro/acesso" element={<PartnerAccess />} />
          <Route path="/parceiro/painel/:token" element={<PartnerPanel />} />
          <Route path="/parceiro/:slug" element={<PartnerLanding />} />
          <Route path="/vendedor/:slug" element={<AffiliateLanding />} />
          <Route path="/calcular-perda" element={<CalcularPerda />} />
          <Route path="/feira" element={<CadastroFeira />} />
          <Route path="/ok/:token" element={<PaginaOK />} />
          <Route path="/parceiro/cadastro" element={<CadastroParceiro />} />
          <Route path="/afiliado/cadastro" element={<CadastroAfiliado />} />
          <Route path="/apresentacao" element={<Apresentacao />} />
          <Route path="/auth/magic-redirect" element={<MagicRedirect />} />
          {/* Resgate de links antigos quebrados: /:slug/dashboard*, /:slug/settings* → redireciona pra rota correta */}
          <Route path="/:slug/dashboard" element={<Navigate to="/plans" replace />} />
          <Route path="/:slug/dashboard/*" element={<Navigate to="/plans" replace />} />
          <Route path="/:slug/settings" element={<Navigate to="/settings" replace />} />
          <Route path="/:slug/settings/*" element={<Navigate to="/settings" replace />} />
          <Route path="/:slug" element={<FeedbackForm />} />
        </Routes>
        <Toaster position="top-center" richColors />
        <CookieConsent />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
